import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IEnquirySearch, IEnquiryDetail, IEnquiryInsert, IEnquiryUpdate, ISupplierOfferSearch, ISupplierOfferDetails, ISupplierOfferInsert, ISupplierOfferUpdate } from "./enquiryTypes";



class EnquiryService {
    async page(searchVo: IEnquirySearch, config: object = {}) {
        const apiUrl = "/gtm/inquiry/listPage";
        return await httpRequest.post<IPage<IEnquiryDetail>>(apiUrl, searchVo, config);
    }
    async insert(insertVo: IEnquiryInsert) {
        const apiUrl = "/gtm/inquiry/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IEnquiryUpdate) {
        const apiUrl = "/gtm/inquiry/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    async one(id: string) {
        const apiUrl = `/gtm/inquiry/findByIdOrCode/${id}`;
        return await httpRequest.get<IEnquiryDetail>(apiUrl);
    }
    async oneFromRealCode(realCode: string) {
        const apiUrl = `/gtm/inquiry/findByIdReCode/${realCode}`;
        return await httpRequest.get<IEnquiryDetail>(apiUrl);
    }
    
    //转报价合同
    async transferQuottion(id: string) {
        const apiUrl = ` /gtm/inquiry/transfer/${id}`;
        return await httpRequest.get<IEnquiryDetail>(apiUrl);
    }
    //作废
    async disable(id: string) {
        const apiUrl = `/gtm/inquiry/disable/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //列表导出
    async export(searchVo: IEnquirySearch) {
        const appPageUrl = "/gtm/inquiry/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //明细导出
    async detailExport(code: string, shopCode: string) {
        const appPageUrl = `/gtm/inquiry/exportDetails/${code}/${shopCode}`;
        return await httpRequest.getFile(appPageUrl);
    }

    //询价单明细模板下载
    async downloadTpl() {
        const appPageUrl = "/gtm/inquiry/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

    /**供应商报价 */
    async pageOffer(searchVo: ISupplierOfferSearch, config: object = {}) {
        const apiUrl = "/gtm/supplierOffer/listPage";
        return await httpRequest.post<IPage<ISupplierOfferDetails>>(apiUrl, searchVo, config);
    }
    async insertOffer(insertVo: ISupplierOfferInsert) {
        const apiUrl = "/gtm/supplierOffer/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async updateOffer(updateVo: ISupplierOfferUpdate) {
        const apiUrl = "/gtm/supplierOffer/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    async oneOffer(id: string) {
        const apiUrl = `/gtm/supplierOffer/findByIdOrCode/${id}`;
        return await httpRequest.get<ISupplierOfferDetails>(apiUrl);
    }
    async disableOffer(id: string) {
        const apiUrl = `/gtm/supplierOffer/disable/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //出口报价
    async transferOffer(vo: { "code": string, "shopCode": string }) {
        const apiUrl = "/gtm/supplierOffer/transfer";
        return await httpRequest.post<string>(apiUrl, vo);
    }
    //供应商报价明细导出
    async offerExport(HRcode: string, shopCode: string) {
        const appPageUrl = `/gtm/supplierOffer/exportDetails/${HRcode}/${shopCode}`;
        return await httpRequest.getFile(appPageUrl);
    }
    //供应商报价模板下载
    async offerDownloadTpl() {
        const appPageUrl = "/gtm/supplierOffer/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
    //供应商报价商品模板下载
    async offerGoodsDownloadTpl(code: string, shopCode: string) {
        const appPageUrl = `/gtm/supplierOffer/detail/downloadTpl/${code}/${shopCode}`;
        return await httpRequest.getFile(appPageUrl);
    }

    //报关修改顺位
    async customsOrderNum(obj: any) {
        const apiUrl = "/gtm/customs/updateOrderNum";
        return await httpRequest.post<string>(apiUrl, obj);
    }
    //询价修改顺位
    async inquiryOrderNum(obj: any) {
        const apiUrl = "/gtm/inquiry/updateOrderNum";
        return await httpRequest.post<string>(apiUrl, obj);
    }
    //报价修改顺位
    async offerOrderNum(obj: any) {
        const apiUrl = "/gtm/offer/updateOrderNum";
        return await httpRequest.post<string>(apiUrl, obj);
    }
    //外贸合同修改顺位
    async saleOrderNum(obj: any) {
        const apiUrl = "/gtm/sale/updateOrderNum";
        return await httpRequest.post<string>(apiUrl, obj);
    }
    //采购修改顺位
    async purchaseOrderNum(obj: any) {
        const apiUrl = "/gtm/purchase/updateOrderNum";
        return await httpRequest.post<string>(apiUrl, obj);
    }
    // //出运修改顺位
    async shipmentOrderNum(obj: any) {
        const apiUrl = "/gtm/shipment/updateOrderNum";
        return await httpRequest.post<string>(apiUrl, obj);
    }
}

export const enquiryService = new EnquiryService();
